module.exports = __webpack_public_path__ + "ac65a04f3a95591b9ce1b1cd129d3942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-rabbit-got-it2.png
// module id = 2024
// module chunks = 4